export * from './login-layout/login-layout.component';
export * from './footer-layout/footer-layout.component';



// WEBPACK FOOTER //
// ./src/app/layouts/index.ts